export default {
  setTimerValue({ commit }, payload) {
    return new Promise((resolve) => {
      commit('SETTIMERVALUE', payload);
      resolve();
    });
  },
};
